import React from 'react';

export const Grid = ({ children }) => (
  <div className={`w-full grid grid-cols-12 gap-4`}>{children}</div>
);

export const GridColumn = ({ children, width = 12 }) => {
  const classes = {
    '1': 'col-span-1',
    '2': 'col-span-2',
    '3': 'col-span-3',
    '4': 'col-span-4',
    '5': 'col-span-5',
    '6': 'col-span-6',
    '7': 'col-span-7',
    '8': 'col-span-8',
    '9': 'col-span-9',
    '10': 'col-span-10',
    '11': 'col-span-11',
    '12': 'col-span-12',
  }
  return <div className={`${classes[width.toString()]}`}>{children}</div>
};

export const Row = ({ children, className = '' }) => (
  <div className={`w-full flex flex-col md:flex-row justify-between mb-4 ${className}`}>{children}</div>
);

export const Column = ({ children, className = '' }) => (
  <div className={`flex flex-row flex-1 ${className}`}>{children}</div>
);

export const RightComponents = ({ children, className = '', wrap = false }) => (
  <div className={`flex flex-wrap ${wrap ? '' : 'md:flex-nowrap'} justify-start items-center gap-2 ${className}`}>{children}</div>
);

export const LeftComponents = ({ children, className = '', wrap = false }) => (
  <div className={`flex flex-wrap ${wrap ? '' : 'md:flex-nowrap'} justify-end items-center gap-2 ${className}`}>{children}</div>
);

export const Components = ({ children, className = '' }) => (
  <div className={`flex flex-col items-center gap-2 ${className}`}>{children}</div>
); 